import { simpleSet } from '@r/reducers/utils';

const setCalculationModeWithInstallation = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.information.withInstallation;

export const withInstallation = setCalculationModeWithInstallation(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_WITH_INSTALLATION',
  true
);
